import http from '@/plugins/http-common'
import {OrderByVariants} from './constants'
import {ResponseData} from './types'

export type GetListParams = {
    limit: null | number,
    offset: null | number,
    order_by: null | OrderByVariants,
    sort_by: null | string,
}

class MessagesService {
    getList = (params: GetListParams): Promise<ResponseData> => http.get('/messages/dialogs', {params})
}

export default new MessagesService()